import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9319 3H8.93195C6.72281 3 4.93195 4.79086 4.93195 7V17C4.93195 19.2091 6.72281 21 8.93195 21H12.9319",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.79578 12L18.5681 12",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5681 15.5L19.0681 12L15.5681 8.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLogout;
